export const NPHIES_INTENDED_STAY_CODES = ['ISD', 'IO'];
export const NPHIES_DISCHARGE_DISPOSITIONS = ['home', 'LAMA', 'died', 'acute-hospital', 'DTPH', 'DTRAS', 'DTOHA', 'SDTC', 'SDFL', 'in-hospital'];
export const DISCHARGE_DISPOSITION_CHOICES = NPHIES_DISCHARGE_DISPOSITIONS.filter((code) => code !== 'in-hospital');
export const ICD10_CODE_PATTERN = /^[A-Z][0-9]{2}(?:\.[0-9A-Z]{1,4})?$/;
const DISPOSITION_BY_STATUS = {
    discharged: 'home',
    lama: 'LAMA',
    expired: 'died',
    referred: 'acute-hospital',
    transferred: 'acute-hospital',
    absconded: 'LAMA',
};
export function defaultDischargeDisposition(status) {
    return DISPOSITION_BY_STATUS[status] ?? null;
}
export function isIntendedStayCode(value) {
    return typeof value === 'string' && NPHIES_INTENDED_STAY_CODES.includes(value);
}
export function isDischargeDisposition(value) {
    return typeof value === 'string' && NPHIES_DISCHARGE_DISPOSITIONS.includes(value);
}
export function intendedStayFromEstimate(days) {
    return days === 0 ? 'ISD' : 'IO';
}
export function diedMatchesStatus(status, disposition) {
    return disposition === null || disposition === undefined || (disposition === 'died') === (status === 'expired');
}
//# sourceMappingURL=admission-stay-codes.js.map